import React, { Component, ErrorInfo, ReactNode } from 'react'
import { Layout, Result, Button } from 'antd'

const { Content } = Layout

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Customer Portal Error Boundary caught an error:', error, errorInfo)
  }

  private handleReload = () => {
    window.location.reload()
  }

  private handleGoHome = () => {
    window.location.href = '/'
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Layout style={{ minHeight: '100vh', background: '#f5f5f5' }}>
          <Content style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            padding: '48px'
          }}>
            <Result
              status="500"
              title="Something went wrong"
              subTitle="We're sorry, but something unexpected happened. Please try refreshing the page or contact support if the problem persists."
              extra={[
                <Button type="primary" key="reload" onClick={this.handleReload}>
                  Refresh Page
                </Button>,
                <Button key="home" onClick={this.handleGoHome}>
                  Go Home
                </Button>
              ]}
              style={{
                background: 'white',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                padding: '48px',
                maxWidth: '600px'
              }}
            />
          </Content>
        </Layout>
      )
    }

    return this.props.children
  }
}
